var exports = {
  "nM": "MacPermissionsSettingsRow.module__row___QVYzaE",
  "Qq": "MacPermissionsSettingsRow.module__text___QVYzaE",
  "DD": "MacPermissionsSettingsRow.module__title___QVYzaE",
  "h_": "MacPermissionsSettingsRow.module__description___QVYzaE",
};

module.exports = exports;
